import React, { useEffect, useState } from "react";
import { api, errMsg } from "@finance/lib/api";
import { toast } from "sonner";
import { Button } from "@finance/components/ui/button";
import { Input } from "@finance/components/ui/input";

const WRITE = /^(\+|new\b|add\b|save|create|edit\b|delete|remove|approve|reject|submit|post\b|record|pay\b|pay |confirm|upload|finali[sz]e|import\b|apply|reverse|resubmit|generate|mark\b|send|deactivate|reactivate|request|settle|allocate|assign|lock|unlock|close|reopen|bulk)/i;
const ALLOW = /(pdf|export|download|print|view|preview|excel|csv template|template|refresh|filter|search|cancel|close dialog)/i;

function sweep() {
  document.querySelectorAll(".lx-readonly button, .lx-readonly [role='button']").forEach((b) => {
    if (b.dataset.roAllow !== undefined) return;
    const t = (b.textContent || b.getAttribute("title") || "").trim();
    if (t && WRITE.test(t) && !ALLOW.test(t)) b.style.display = "none";
  });
}

export function ReadOnlyGuard() {
  useEffect(() => {
    sweep();
    const mo = new MutationObserver(() => sweep());
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, []);
  return <div className="sticky top-0 z-30 bg-amber-100 px-8 py-1 text-xs font-medium text-amber-800" data-testid="readonly-banner">Read-only access — you can view and export, but not change anything.</div>;
}

export function ForcePasswordChange() {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const save = async () => {
    if (f.new_password !== f.confirm) { toast.error("New passwords don't match."); return; }
    try { await api.post("/auth/change-password", f); toast.success("Password changed"); window.location.reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60" data-testid="force-password-change">
      <div className="w-full max-w-sm space-y-3 rounded-xl bg-white p-6 shadow-xl">
        <div className="font-display text-lg font-bold text-gray-900">Set a new password</div>
        <p className="text-xs text-gray-500">For security, you must change the temporary password before continuing.</p>
        <Input type="password" placeholder="Current (temporary) password" data-testid="fpc-current" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} />
        <Input type="password" placeholder="New password (min 8 characters)" data-testid="fpc-new" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} />
        <Input type="password" placeholder="Confirm new password" data-testid="fpc-confirm" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} />
        <Button className="w-full bg-[#1B4383]" data-ro-allow data-testid="fpc-save" onClick={save}>Change password</Button>
      </div>
    </div>
  );
}
